/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { IApplicationLog } from 'generated-types';
import { Pipe, PipeTransform } from '@angular/core';

type TNsxAlbInfo = Pick<IApplicationLog, 'request_id' | 'redirected_uri' | 'response_length'>;

/* eslint-disable @typescript-eslint/naming-convention */
/**
 * @description
 *     Pipe for extracting DNS Load Balance info from an L4 log.
 * @author Zhiqian Liu
 */
@Pipe({
    name: 'nsxAlbInfo',
})
export class NsxAlbInfoPipe implements PipeTransform {
    /** @override */
    // eslint-disable-next-line class-methods-use-this
    public transform(log: IApplicationLog): TNsxAlbInfo {
        if (!log) {
            return {};
        }

        const {
            request_id,
            redirected_uri,
            response_length,
        } = log;

        return {
            request_id,
            redirected_uri,
            response_length,
        };
    }
}
